import { Input, Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { FromNowPipe } from "../../pipes/fromnow.pipe";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormGroup, FormControl } from "@angular/forms";
import { CountryDataTimelineEventService } from "../../services/countrydatatimelineevent.service";
import { CountryDataTimeline, CountryDataTimelineCommentDto } from "../../models/countrydatatimeline";

@Component({
    selector: "countrydatatimeline",
    templateUrl: "./countrydatatimeline.component.html",
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FromNowPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})

export class CountryDataTimelineComponent implements OnInit {

    @Input() events: CountryDataTimeline[];
    @Input() countryName: string;
    @Input() workFlowStageId: number;
    @Input() countryDataId: number;
    @Input() countryCode: string;

    timelineCommentForm: FormGroup;

    public constructor(private timelineService: CountryDataTimelineEventService) {

    }

    ngOnInit(): void {
        this.timelineCommentForm = new FormGroup({
            comment: new FormControl(""),
            countryDataId: new FormControl(this.countryDataId),
            workFlowStageId: new FormControl(this.workFlowStageId),
            countryCode: new FormControl(this.countryCode)
        });
    }

    public post(form: CountryDataTimelineCommentDto): void {
        this.timelineService.create(form).subscribe((results) => {
            this.events = results;
            this.timelineCommentForm.controls["comment"].setValue("");
        });
    }
}



